import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { AdminStatCard } from "./AdminStatCard";
import { RefreshCw, DollarSign, AlertTriangle, TrendingUp, FileText, CalendarDays } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminFaturimi = ({ cars }) => {
  const [invoices, setInvoices] = useState([]);
  const [stats, setStats] = useState({ total: 0, unpaid: 0, overdue: 0, paid_this_month: 0 });
  const [filter, setFilter] = useState("all");

  useEffect(() => { loadInvoices(); loadStats(); }, [filter]);

  const loadInvoices = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      const res = await axios.get(`${API}/admin/invoices?filter=${filter}`, { headers: { Authorization: `Bearer ${token}` } });
      setInvoices(res.data);
    } catch (e) { console.error(e); }
  };

  const loadStats = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      const res = await axios.get(`${API}/admin/invoices/stats`, { headers: { Authorization: `Bearer ${token}` } });
      setStats(res.data);
    } catch (e) { console.error(e); }
  };

  const getCarName = (carId) => {
    const car = (cars || []).find(c => c.id === carId);
    return car ? `${car.brand} ${car.model}` : carId;
  };

  const paymentLabel = (s) => {
    const m = { paid: "Paguar", pending: "Pa paguar", partial: "Pjesërisht" };
    return m[s] || "Pa paguar";
  };

  const paymentColor = (s) => {
    const m = { paid: "bg-green-600/20 text-green-500", pending: "bg-yellow-600/20 text-yellow-500", partial: "bg-orange-600/20 text-orange-500" };
    return m[s] || m.pending;
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-white">Faturimi</h2>
      </div>

      <div className="grid grid-cols-2 gap-3 mb-6">
        <AdminStatCard value={stats.unpaid} label="Pa paguar" color="yellow" icon={<DollarSign className="h-5 w-5" />} active={filter === "unpaid"} onClick={() => setFilter(filter === "unpaid" ? "all" : "unpaid")} />
        <AdminStatCard value={stats.overdue} label="Të vonuara" color="red" icon={<AlertTriangle className="h-5 w-5" />} active={filter === "overdue"} onClick={() => setFilter(filter === "overdue" ? "all" : "overdue")} />
        <AdminStatCard value={`€${stats.paid_this_month}`} label="Paguar ky muaj" color="green" icon={<TrendingUp className="h-5 w-5" />} />
        <AdminStatCard value={stats.total} label="Gjithsej fatura" color="blue" icon={<FileText className="h-5 w-5" />} />
      </div>

      <div className="flex gap-3 mb-6">
        <select value={filter} onChange={(e) => setFilter(e.target.value)} className="flex-1 bg-zinc-800 border border-gray-700 text-white rounded-md px-3 py-2">
          <option value="all">Të gjitha</option>
          <option value="unpaid">Pa paguar</option>
          <option value="overdue">Të vonuara</option>
          <option value="paid">Paguar</option>
        </select>
        <Button variant="outline" onClick={() => { loadInvoices(); loadStats(); }} className="border-gray-700 text-gray-400">
          <RefreshCw className="h-4 w-4" />
        </Button>
      </div>

      {invoices.length === 0 ? (
        <div className="text-center py-16 text-gray-500">
          <FileText className="h-12 w-12 mx-auto mb-3 opacity-30" />
          <p className="font-medium">Nuk u gjetën fatura</p>
          <p className="text-sm mt-1">Faturat krijohen automatikisht nga rezervimet</p>
        </div>
      ) : (
        <div className="space-y-3">
          {invoices.map((inv) => (
            <div key={inv.id} className="bg-zinc-900 border border-gray-800 rounded-xl p-4 hover:border-gray-700 transition-colors" data-testid={`invoice-${inv.id}`}>
              <div className="flex justify-between items-start">
                <div>
                  <p className="text-white font-semibold">{inv.customer_name}</p>
                  <p className="text-gray-400 text-sm">{getCarName(inv.car_id)}</p>
                  <p className="text-gray-500 text-xs mt-1">
                    <CalendarDays className="h-3 w-3 inline mr-1" />
                    {inv.pickup_date?.slice(0,10)} → {inv.return_date?.slice(0,10)}
                  </p>
                </div>
                <div className="text-right">
                  <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${paymentColor(inv.payment_status)}`}>
                    {paymentLabel(inv.payment_status)}
                  </span>
                  <p className="text-yellow-500 font-bold text-lg mt-1">€{inv.total_price?.toFixed(2)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
